// src/components/Modals/UpdateSealNumberModal.jsx
import React, { useState } from "react";
import { FiX } from "react-icons/fi";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import { updateSealNumber } from "../../ApiController/ApiService";

const UpdateSealNumberModal = ({ show, onClose, shipmentId, onSuccess }) => {
  const { t } = useTranslation();
  const [sealNumber, setSealNumber] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!sealNumber.trim()) {
      Swal.fire(t("alerts.errorTitle", "Error"), t("alerts.enterSealNumber", "Please enter a valid seal number"), "error");
      return;
    }

    setLoading(true);
    try {
      // ✅ payload key matches backend expectation
      const payload = { sealNumber };

      // ✅ call API
      const res = await updateSealNumber(shipmentId, payload);

      // ✅ handle success
      if (res?.status === 200 || res?.ok) {
        Swal.fire(t("alerts.successTitle", "Success!"), t("alerts.updateSuccess", "Seal number updated successfully."), "success");
        onSuccess?.(); // refresh parent data
        onClose();
        setSealNumber(""); // reset field
      } else {
        throw new Error(res?.message || t("alerts.updateFailed", "Failed to update seal number."));
      }
    } catch (error) {
      Swal.fire(t("alerts.errorTitle", "Error"), error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div
        className="rounded-xl shadow-xl text-white p-6 relative w-[90%] sm:w-[400px]"
        style={{
          background:
            "radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)",
        }}
      >
        {/* ❌ Close Button */}
        <button
          onClick={onClose}
          type="button"
          className="absolute top-2 right-3 text-2xl font-bold"
        >
          <FiX />
        </button>

        <h2 className="text-lg font-bold mb-4 text-center">
          {t("orders.sealNumberButton")}
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-sm block mb-1">
              {t("orders.sealNumber")}
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 rounded bg-white text-black text-sm"
              value={sealNumber}
              onChange={(e) => setSealNumber(e.target.value)}
              placeholder={t("orders.sealNumberPlaceholder")}
            />
          </div>

          <button
            type="submit"
            className="w-full py-2 bg-[#6F1AFF] text-white rounded-lg hover:opacity-90 transition"
            disabled={loading}
          >
            {loading ? t("orders.updating") : t("orders.update")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default UpdateSealNumberModal;
